import * as React from 'react';
import {styled} from '../../utils';
import Text from '../Text';
import Persona, {PersonaProps} from '../Persona';
import {PersonaStackProps} from './types';

const Root = styled('div')({
  display: 'inline-block'
});

const List = styled('ul')({
  listStyle: 'none'
});

const ListItem = styled('li')({
  display: 'inline-block'
});

export default class PersonaStack extends React.Component<PersonaStackProps, {}> {
  public static defaultProps = {
    separator: <span style={{marginRight: 3}}>,</span>
  };

  public render() {
    const {children, maxLength, separator, ...restProps} = this.props;

    const numberOfItems = React.Children.count(children);

    const numberOfExcessiveItems = numberOfItems - maxLength;

    const displayItems = React.Children.map(children, (child, index) => {
      const isLast = index === numberOfItems - 1;

      if (index < maxLength && React.isValidElement(child) && child.type === Persona) {
        return (
          <ListItem>
            <Persona {...child.props as PersonaProps} />
            {isLast ? null : separator}
          </ListItem>
        );
      }
      return null;
    });

    const moreItems = numberOfExcessiveItems > 0 ? <Text>and {numberOfExcessiveItems} more</Text> : null;

    return (
      <Root {...restProps}>
        <List>
          {displayItems}
          {moreItems}
        </List>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PersonaStack/PersonaStack.tsx